var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnapChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6.79166C14.5 -0.708401 4.5 -0.708367 4.5 6.79166V8.04166L3.14359 8.04164C2.65717 8.04164 2.45715 8.66578 2.85297 8.94851L4.5 10.125C4.22222 11.0972 3.08333 13.2083 0.75 13.875C1.02778 14.2916 1.83333 15.125 2.83333 15.125L3.66667 16.375L5.75 15.9583C6.44444 16.5138 8.16667 17.625 9.5 17.625C10.8333 17.625 12.5556 16.5138 13.25 15.9583L15.3333 16.375L16.1667 15.125C17.1667 15.125 17.9722 14.2916 18.25 13.875C15.9167 13.2083 14.7778 11.0972 14.5 10.125L15.8931 9.12989C16.3681 8.79061 16.1281 8.04164 15.5444 8.04165L14.5 8.04166V6.79166Z",
    stroke: "#1C38F1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapChat);
export default __webpack_public_path__ + "static/media/SnapChat.1268ac4c3d3916e0bf3feea541ee7bae.svg";
export { ForwardRef as ReactComponent };